import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

const mutateAddQualityChecklistItem = async ({
  checklistId,
  data,
}: {
  checklistId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${QUALITY_CHECKLIST_API}/${checklistId}/items`,
    data
  );
};

const useAddQualityChecklistItemMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      checklistId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddQualityChecklistItem,
    ...queryParams,
  });

export default useAddQualityChecklistItemMutation;
